export default __webpack_public_path__ + "static/media/greeting17.aa1fc98d.png";